export const sendMail = async(params: SendMailParameter): Promise<boolean> => {
	const apiUrl = 'https://hfznne7iag.execute-api.ap-northeast-1.amazonaws.com';

	try {
		const res = await fetch(
			apiUrl,
			{
				method: 'POST',
				mode: 'cors',
				body: JSON.stringify(params),
				headers: {
					'Content-Type': 'application/json'
				}
			}
		);

		if (!res.ok) {
			console.error(res);
			throw new Error(`Error SendForm: ${res.status}`);
		}

		return true;
	} catch (error) {
		console.error(`Error SendMail: `, error);
		return false;
	}
}
